<template>
  <ReviewCategoriesChartWrapper
    :is-loading="isLoading"
    @get-chart-data="getChartData"
  >
    <template v-slot:chart>
      <LineChart
        :data="chartData"
        :labels="chartLabels"
        :max-value="maxValue"
        :min-value="minValue"
        :selected-category="selectedCategory"
      />
    </template>
  </ReviewCategoriesChartWrapper>
</template>

<script>
import LineChart from "@/components/Reviews/Categories/LineChart";
import { REVIEWS_DATA_PERIOD } from "@/enums/reviews-data-period.enum";
import ReviewCategoriesChartWrapper from "@/components/Reviews/Categories/ReviewsCategoriesChartWrapper.vue";
import { ReviewCategoriesChartMixin } from "@/helpers/mixins/review-categories-chart";

export default {
  name: "ReviewsCategoriesLineChart",
  components: {
    LineChart,
    ReviewCategoriesChartWrapper
  },
  mixins: [ReviewCategoriesChartMixin],
  props: {
    maxValue: {
      type: Number
    },
    minValue: {
      type: Number
    }
  },
  data() {
    return {
      chartData: {
        basic: [],
        comparison: [],
        tooltip: {
          basic: [],
          comparison: []
        }
      },
      chartLabels: [],
      chartFilter: REVIEWS_DATA_PERIOD.WEEK
    };
  },

  methods: {
    async getChartData(view) {
      this.isLoading = true;
      this.chartFilter = view;
      const { basic, comparison } = await this.fetchMethod({
        view,
        fieldName: this.fieldName
      });

      this.chartData.basic = basic.map(item => item[this.fieldName]);
      this.chartData.tooltip.basic = basic.map(({ count }) => ({
        count
      }));

      this.chartData.comparison = comparison.length
        ? comparison.map(item => item[this.fieldName])
        : comparison;

      this.chartData.tooltip.comparison = comparison.length
        ? comparison.map(({ count }) => ({
            count
          }))
        : [];

      this.chartLabels = this.getChartLabels(basic, comparison);
      this.isLoading = false;
    }
  }
};
</script>
